import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#fdfbf7]',
    white: 'bg-white',
    navy: 'bg-[#1e3a5f] text-white'
  };
  return <section id={id} className={`py-6 md:py-8 ${bgColors[background]} ${className}`} data-id="element-400">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.5
    }} className="max-w-3xl mx-auto px-6 md:px-8" data-id="element-401">
        {children}
      </motion.div>
    </section>;
}